import { createFileRoute } from '@tanstack/react-router';
import { TeachersView } from '@/components/TeachersView';

export const Route = createFileRoute('/_authenticated/teachers')({
  component: TeachersView,
});

